import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { CustomContainer } from "../../../atoms/DependencyHelper";
import InlineItem from "../inlineItem/InlineItem";
import LabelText from "../../../atoms/label/LabelText";
import labels from "../../../../config/labels";
import SnackBar from "../../../atoms/snackBar/SnackBar";
import styles from "./ItemsDetails.module.scss";

const ItemsDetails = ({
  customerStatus,
  cartId,
  cartProducts,
  className,
  itemLabel,
  priceLabel,
  price,
}) => {
  const [cartProductName, setCartProductName] = useState(null);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [isRemove, setIsRemove] = useState(false);

  const dealProduct = cartProducts.find(
    (cartProduct) => cartProduct?.product?.is_deal_product === 1
  );

  const dealSku = dealProduct?.product?.sku;

  let paymentTerms = null;
  paymentTerms = dealProduct?.product?.payment_terms_label;

  useEffect(() => {
    if (showSnackBar) {
      let timer = setTimeout(() => closeSnackBar(), 3000);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [showSnackBar]);

  const displaySnackBar = (value, name) => {
    setCartProductName(name);
    setShowSnackBar(true);
    setIsRemove(value);
  };

  const closeSnackBar = () => {
    setCartProductName(null);
    setShowSnackBar(false);
    setIsRemove(false);
  };

  return (
    <>
      <CustomContainer className={`${styles["item-details"]} ${className}`}>
        <CustomContainer
          className={styles["item-details__top"]}
          id={`item-main-label-checkout-review`}
        >
          <LabelText className={`${styles["total-item-label"]}`}>
            {itemLabel}
          </LabelText>
        </CustomContainer>

        <CustomContainer className={styles["item-details__mid"]}>
          {cartProducts.map((cartProduct) => (
            <InlineItem
              key={cartProduct.id}
              customerStatus={customerStatus}
              cartId={cartId}
              dealSku={dealSku}
              paymentTerms={paymentTerms}
              cartProduct={cartProduct}
              displaySnackBar={displaySnackBar}
            />
          ))}
        </CustomContainer>

        <CustomContainer
          className={styles["item-details__bottom"]}
          id={`total-due-amount-checkout-review`}
        >
          <LabelText
            className={styles["total-price-label"]}
            uniqueLabelId={`total-due-label-child`}
          >
            {priceLabel}
          </LabelText>

          <LabelText
            className={styles["total-price"]}
            uniqueLabelId={"total-price-label"}
          >
            {price}
          </LabelText>
        </CustomContainer>
      </CustomContainer>

      {showSnackBar && (
        <SnackBar
          message={ isRemove
            ? `${cartProductName} ${labels.lbl_removed_from_cart}`
            : labels.lbl_updated_cart
          }
          className={styles["snack-bar-styling"]}
          closeSnackBar={closeSnackBar}
          isVisible={showSnackBar}
        />
      )}
    </>
  );
};

ItemsDetails.propTypes = {
  cartProducts: PropTypes.array,
  cartId: PropTypes.string,
  customerStatus: PropTypes.string,
  className: PropTypes.string,
  itemLabel: PropTypes.string,
  priceLabel: PropTypes.string,
  price: PropTypes.string,
};

ItemsDetails.defaultProps = {
  cartProducts: [],
};

export default ItemsDetails;
